import React from "react";
import { observer } from "mobx-react";
import { WeaColorPicker } from "ecCom";

@observer
export default class ColorPickerItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaColorPicker
        ecId={`${this.props.ecId}_WeaColorPicker@h1e8s3`}
        {...bindObj.bind()}
        onChange={this.onChange}
        {...c}
        {...c.otherParams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/ColorPickerItem.js